import { InMemoryWebStorage } from "oidc-client-ts";

const embeddedLocal = new InMemoryWebStorage();
const embeddedSession = new InMemoryWebStorage();

export const DOCEBO_ENTRY_PATH = "/oauth/auto-login";

/** Temporary: the only LMS whose iframes run on the top-level cookie session instead of a Docebo launch. */
const SHARED_SESSION_EMBEDDER_HOST = "360learning.com";

let embedded: boolean | undefined;

function sharesTopLevelSession(referrer: string): boolean {
  try {
    const { protocol, hostname } = new URL(referrer);
    return (
      protocol === "https:" &&
      (hostname === SHARED_SESSION_EMBEDDER_HOST || hostname.endsWith(`.${SHARED_SESSION_EMBEDDER_HOST}`))
    );
  } catch {
    return false;
  }
}

/**
 * An iframe never restores or publishes the top-level account, except a 360Learning embed, which
 * shares it through cookies. Decided once per document: the Docebo widget leaves its entry path as
 * soon as it is logged in.
 */
export function isEmbeddedAuth(): boolean {
  if (typeof window === "undefined") return false;
  embedded ??=
    window.self !== window.top &&
    (window.location.pathname === DOCEBO_ENTRY_PATH || !sharesTopLevelSession(window.document.referrer));
  return embedded;
}

export function authLocalStorage(): Storage {
  return isEmbeddedAuth() ? embeddedLocal : window.localStorage;
}

export function authSessionStorage(): Storage {
  return isEmbeddedAuth() ? embeddedSession : window.sessionStorage;
}

export function authEntryPath(): string {
  return isEmbeddedAuth() ? DOCEBO_ENTRY_PATH : "/";
}
